module.exports = __webpack_public_path__ + "img/shield-and-sword.fe1acda8.svg";